import {Link} from 'react-router'
import './Manager.css'
import ManagerNavbar from './components/ManagerNavbar.jsx'
import { FaToggleOff } from "react-icons/fa6";
import { FaToggleOn } from "react-icons/fa6";
import {useState,useEffect} from 'react'

export default function Events(){

    const BASE_URL = (process.env.NODE_ENV == 'production') ?
                    'https://olea-iwpz.onrender.com' : 
                    'http://localhost:1436'

    useEffect(()=>getAnnualEvents(),[])

    const [dailySpecials, setDailySpecials] = useState(true)
    const [mothersDay, setMothersDay] = useState(false)
    const [commencement, setCommencement] = useState(false)
    const [oleaAnniversary, setOleaAnniversary] = useState(false)
    const [parentsWeekend, setParentsWeekend] = useState(false)
    const [graduationLunch, setGraduationLunch] = useState(false)
    const [restaurantWeeksFall, setRestaurantWeeksFall] = useState(false)

    function getAnnualEvents(){
        try{
            fetch(`${BASE_URL}/api/annual-events`)
                .then(res=>res.json())
                .then(json=>{
                    setDailySpecials(json[0].DailySpecials)
                    setMothersDay(json[0].MothersDay)
                    setCommencement(json[0].Commencement)
                    setOleaAnniversary(json[0].OleaAnniversary)
                    setGraduationLunch(json[0].GraduationLunch)
                    setParentsWeekend(json[0].ParentsWeekend)
                    setRestaurantWeeksFall(json[0].RestaurantWeeksFall)
                })
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function toggleMothersDay(){
        try{
            fetch(`${BASE_URL}/api/toggle-mothers-day`)
                .then(()=>getAnnualEvents())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function toggleAnnualEvent(annualEvent){
        // alert(annualEvent)
        try{
            fetch(`${BASE_URL}/api/toggle/${annualEvent}`)
                .then(()=>getAnnualEvents())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    return(
        <>
            <div    className='manager-page-wrapper' 
                    // style={{border:'1px solid red'}}
            >
                <ManagerNavbar page='events' />
                    <div style={{textAlign:'center',fontSize:'30px'}}>menu manager</div>
                    <div style={{textAlign:'center',fontSize:'30px'}}>events</div>
                    <ul className='main-menu' 
                        style={{display:'flex',
                                flex:'1',
                                flexDirection:'column',
                                gap:'10px',
                                justifyContent:'space-evenly',
                                alignItems:'center',
                                height:'100%',
                                // border:'1px solid green'
                                }}>

                        <div style={{display:'flex',gap:'10px'}}>
                            
                                <li style={{flexGrow:'1'}}>daily<br/>specials</li>
                            

                            <div style={{display:'flex',alignItems:'center',gap:'20px',border:'1px solid black',borderRadius:'10px',width:'150px',justifyContent:'center'}}>
                                <div style={{textAlign:'center'}}>website<br/>menu</div>
                                {dailySpecials ? 
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOn size='30' style={{color:'green',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('DailySpecials')} /> &nbsp;ON
                                                </div>

                                            :
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOff size='30' style={{color:'red',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('DailySpecials')} /> &nbsp;OFF
                                                </div>
                                }
                            </div>
                        </div>



                        <Link to='/valentines-day'><li style={{flexGrow:'1'}}>valentine's day<br/>feb 14</li></Link>
                        <Link to='/restaurant-weeks-spring'><li style={{flexGrow:'1'}}>restaurant weeks<br/>late march</li></Link>
                        
                        <div style={{display:'flex',gap:'10px'}}>
                            <Link to='/manager/mothers-day'>
                                <li style={{flexGrow:'1'}}>mother's day<br/>2nd sun may</li>
                            </Link>
                            <div style={{display:'flex',alignItems:'center',gap:'20px',border:'1px solid black',borderRadius:'10px',width:'150px',justifyContent:'center'}}>
                                <div style={{textAlign:'center'}}>website<br/>menu</div>
                                {mothersDay ? 
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOn size='30' style={{color:'green',cursor:'pointer'}} onClick={toggleMothersDay} /> &nbsp;ON
                                                </div>

                                            :
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOff size='30' style={{color:'red',cursor:'pointer'}} onClick={toggleMothersDay} /> &nbsp;OFF
                                                </div>
                                }
                            </div>
                        </div>





                        
                        <div style={{display:'flex',gap:'10px'}}>
                            <Link to='/manager/commencement-dashboard'>
                                <li style={{flexGrow:'1'}}>commencement<br/>3rd sun may</li>
                            </Link>
                            <div style={{display:'flex',alignItems:'center',gap:'20px',border:'1px solid black',borderRadius:'10px',width:'150px',justifyContent:'center'}}>
                                <div style={{textAlign:'center'}}>website<br/>menu</div>
                                {commencement ? 
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOn size='30' style={{color:'green',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('Commencement')} /> &nbsp;ON
                                                </div>

                                            :
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOff size='30' style={{color:'red',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('Commencement')} /> &nbsp;OFF
                                                </div>
                                }
                            </div>
                        </div>
                        
                        {/* <Link to='/events'><li style={{flexGrow:'1'}}>graduation lunch<br/>3rd mon may</li></Link> */}

                        <div style={{display:'flex',gap:'10px'}}>
                            <Link to='/events-anniversary'>
                                <li style={{flexGrow:'1'}}>graduation lunch<br/>3rd mon may</li>
                            </Link>

                            <div style={{display:'flex',alignItems:'center',gap:'20px',border:'1px solid black',borderRadius:'10px',width:'150px',justifyContent:'center'}}>
                                <div style={{textAlign:'center'}}>website<br/>menu</div>
                                {graduationLunch ? 
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOn size='30' style={{color:'green',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('GraduationLunch')} /> &nbsp;ON
                                                </div>

                                            :
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOff size='30' style={{color:'red',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('GraduationLunch')} /> &nbsp;OFF
                                                </div>
                                }
                            </div>
                        </div>

                        {/* <Link to='/events-anniversary'><li style={{flexGrow:'1'}}>anniversary<br/>aug 27</li></Link> */}

                        <div style={{display:'flex',gap:'10px'}}>
                            <Link to='/events-anniversary'>
                                <li style={{flexGrow:'1'}}>anniversary<br/>august 27</li>
                            </Link>

                            <div style={{display:'flex',alignItems:'center',gap:'20px',border:'1px solid black',borderRadius:'10px',width:'150px',justifyContent:'center'}}>
                                <div style={{textAlign:'center'}}>website<br/>menu</div>
                                {oleaAnniversary ? 
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOn size='30' style={{color:'green',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('OleaAnniversary')} /> &nbsp;ON
                                                </div>

                                            :
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOff size='30' style={{color:'red',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('OleaAnniversary')} /> &nbsp;OFF
                                                </div>
                                }
                            </div>
                        </div>
                        
                        <div style={{display:'flex',gap:'10px'}}>
                            <Link to='/parents-weekend'>
                                <li style={{flexGrow:'1'}}>parents weekend<br/>1st sat oct</li>
                            </Link>

                            <div style={{display:'flex',alignItems:'center',gap:'20px',border:'1px solid black',borderRadius:'10px',width:'150px',justifyContent:'center'}}>
                                <div style={{textAlign:'center'}}>website<br/>menu</div>
                                {parentsWeekend ? 
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOn size='30' style={{color:'green',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('ParentsWeekend')} /> &nbsp;ON
                                                </div>

                                            :
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOff size='30' style={{color:'red',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('ParentsWeekend')} /> &nbsp;OFF
                                                </div>
                                }
                            </div>
                        </div>
                        
                        

                        <div style={{display:'flex',gap:'10px'}}>
                            <Link to='/restaurant-weeks'>
                                <li style={{flexGrow:'1'}}>restaurant weeks<br/>1st 2 weeks nov</li>
                            </Link>

                            <div style={{display:'flex',alignItems:'center',gap:'20px',border:'1px solid black',borderRadius:'10px',width:'150px',justifyContent:'center'}}>
                                <div style={{textAlign:'center'}}>website<br/>menu</div>
                                {restaurantWeeksFall ? 
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOn size='30' style={{color:'green',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('RestaurantWeeksFall')} /> &nbsp;ON
                                                </div>

                                            :
                                                <div style={{display:'flex',alignItems:'center'}}>
                                                    <FaToggleOff size='30' style={{color:'red',cursor:'pointer'}} onClick={()=>toggleAnnualEvent('RestaurantWeeksFall')} /> &nbsp;OFF
                                                </div>
                                }
                            </div>
                        </div>
                        
                        

                        <Link to='/nye'><li style={{flexGrow:'1'}}>new year's eve<br/>dec 31</li></Link>
                    </ul>

            
            </div>{/* .manager-page-wrapper */}
        </>
    )
}